import { EntityRequestCaruse } from "../../entity/EntityRequestCaruse";

export class DtoRequestCarusesPostRes extends EntityRequestCaruse {}
